import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import logo from "../../Assets/logo.jpeg";
import { orgInfo } from "../../constants/info";

const SectionHeading = ({
  title,
  subtitle,
  text,
  heading,
  batch,
  shift,
  grade,
  data,
  year,
  month,
  getGradeList,
  noLogo,
}) => {
  useEffect(() => {
    if (!data) {
      getGradeList();
    }
  }, []);
  return (
    <div className="d-flex align-items-center justify-content-center flex-column">
      {noLogo ? <></> : <img src={logo} style={{ height: 80 }} alt="" />}
      <h4 className="pt-2">{orgInfo.ORG_NAME}</h4>
      {heading && <h5 className="text-center">{heading}</h5>}
      {text && <span className="d-block h5 fw-normal">{text}</span>}
      <div className="d-flex justify-content-center pb-4 flex-wrap">
        {data && grade && (
          <span className="d-block  fw-bold px-2">
            Class : {data.filter((grd) => grd.id === parseInt(grade))[0]?.name}
          </span>
        )}
        {data && shift && (
          <span className="d-block  fw-bold px-2">
            Shift :{" "}
            {
              data
                .filter((grd) => grd.id === parseInt(grade))[0]
                ?.shifts.filter((s) => s.id === parseInt(shift))[0]?.name
            }
          </span>
        )}
        {data && batch && (
          <span className="d-block  fw-bold px-2">
            Batch :{" "}
            {
              data
                .filter((grd) => grd.id === parseInt(grade))[0]
                ?.batches.filter((s) => s.id === parseInt(batch))[0]?.name
            }
          </span>
        )}
      </div>
      <div className="d-flex justify-content-center">
        {month && (
          <span className="d-block h6 fw-bold px-3">Month : {month}</span>
        )}
        {year && <span className="d-block h6 fw-bold px-3">Year : {year}</span>}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.grade.grade,
});
export default connect(mapStateToProps, { getGradeList })(SectionHeading);
